import { useEffect, useRef } from 'react';
import { useFirmBaseLayoutContext } from './FirmBaseLayoutContext';
import type { FirmBaseLayoutNavigationRegistrationToken } from './FirmBaseLayoutContext.types';
import type { TertiaryNavigationState } from './tertiaryNavigation.types';

export const useTertiaryNavigationRegistration = (tertiaryNavigation: TertiaryNavigationState | null) => {
  const registrationTokenRef = useRef<FirmBaseLayoutNavigationRegistrationToken>(Symbol('tertiary-navigation'));
  const registrationToken = registrationTokenRef.current;
  const { clearTertiaryNavigation, registerTertiaryNavigation } = useFirmBaseLayoutContext();

  useEffect(() => {
    registerTertiaryNavigation(registrationToken, tertiaryNavigation);

    return () => {
      clearTertiaryNavigation(registrationToken);
    };
  }, [clearTertiaryNavigation, registerTertiaryNavigation, registrationToken, tertiaryNavigation]);
};
